import algolia from "../algolia";
import { infiniteHits, analytics } from "instantsearch.js/es/widgets";
import { useEffect, useState } from "preact/hooks";
import List from "../components/List";

export default function Search(props) {
  useEffect(() => {
    const hitsWidget = infiniteHits({
      container: document.querySelector("#infiniteHits"),
      cssClasses: {
        list: `list-none`,
        item: `border-b border-gray-300 hover:bg-gray-200`,
        loadMore: `mx-auto block mt-3 text-base bg-transparent hover:bg-gray-500 text-gray-700 font-semibold hover:text-white py-2 px-4 border border-gray-500 hover:border-transparent rounded`,
        emptyRoot: "mx-auto my-4 text-gray-800 text-center",
      },
      templates: {
        item: `
          <a class="block py-4 px-4 text-left" href="{{url}}${
            window.location.search
          }" native>
            <div class="flex items-center">
              <div class="flex-shrink-0">
                <img class="m-auto border border-gray-300 rounded-lg w-20" src="{{image_url}}" alt="{{name}}" />
              </div>
              <div class="mt-0 ml-3 w-full">
                <p href="#" class="block mt-1 text-large leading-tight font-semibold text-gray-900">{{#helpers.highlight}}{ "attribute": "name" }{{/helpers.highlight}}</p>
                <div class="${
                  props.hidePrice ? "hidden" : "inline"
                } uppercase tracking-wide text-base text-gray-600 font-bold">$\{{price}}</div>
              </div>
              <div>
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>
              </div>
            </div>
          </a>
        `,
        showMoreText: "Load more",
      },
    });

    const analyticsWidget = analytics({
      pushFunction(formattedParameters, state, results) {
        if (window.ga) {
          window.ga("set", "page", `/ballistic/?query=${state.query}`);
          window.ga("send", "event", "search", "query", state.query);
          window.ga("send", "pageView");
        }
      },
      pushInitialSearch: true,
      triggerOnUIInteraction: true,
    });

    const search = algolia().searchIndex.addWidgets([hitsWidget, analyticsWidget]);

    search.on('render', () => {
      const button = document.querySelector('button.ais-InfiniteHits-loadMore')
      
      if (button) {
        button.type = 'button'
      }
    })   

    return () => {
      algolia().searchIndex.removeWidgets([hitsWidget, analyticsWidget]);
    };
  }, [props.hidePrice]);

  function selectQuickResult(item) {
    window.quickSelect(item);
  }

  return (
    <div class='overflow-hidden h-full'>
      {/* <a href="/feedback" class="float-right text-blue-500 hover:text-blue-800 underline  mr-3 mb-1 text-sm">Can't find something?</a> */}
      <div class='clear-both' />
      <div id='infiniteHits' class='h-full overflow-scroll pb-10 hidden' />
      <div id='initialResults' class='block'>
        {props.quickSearches && (
          <div>
            <div class='flex justify-between border-gray-300 border-b'>
              <h2 class='uppercase pl-4 pb-2 text-sm font-medium text-gray-700 leading-6'>
                Popular:
              </h2>
              {/* {window.hj && (
                <a
                  class='cursor-pointer pr-5 text-xs leading-6 font-semibold text-teal-600 hover:text-teal-500 transition ease-in-out duration-150'
                  onClick={() => {
                    window.hj =
                      window.hj ||
                      function () {
                        (hj.q = hj.q || []).push(arguments);
                      };
                    console.log("feedback");
                    hj("trigger", "search_feedback");
                  }}
                >
                  Feedback
                </a>
              )} */}
            </div>
            <List
              data={props.quickSearches.split(",")}
              onAction={selectQuickResult}
            />
          </div>
        )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./route/Search.js